/* INTEGY V655 — mobile-first canonical navigation + stock URL stabilization. */
(function(){
  'use strict';

  if(!window.IntegyV651Release){
    window.IntegyV651Release={version:'V651',data:'V42-20260916',filterMetadata:'V651-DATA42-6',base:'V650',largeCollectionThreshold:5000,strategy:'Liquid count detection + indexed owner preference + live Shopify stock scan fallback'};
  }
  if(!window.IntegyV652Release){
    window.IntegyV652Release={version:'V652',data:'V42-20260916',base:'V651',focus:'responsive-owner-menu-normalization-cleanup'};
  }
  if(!window.IntegyV653Release){
    window.IntegyV653Release={version:'V653',data:'V42-20260916',base:'V652',focus:'route-menu-labels-stock-first-paint-responsive-card-polish'};
  }
  if(!window.IntegyV654Release){window.IntegyV654Release={version:'V654',data:'V42-20260916',base:'V653',focus:'canonical-nav-owner-default-stock-url-late-layer-consolidation'};}
  window.IntegyV655Release={version:'V655',data:'V42-20260916',base:'V654',focus:'mobile-first-canonical-maxx-label-final-responsive-touch-owner'};

  var ROUTE_LABELS={
    '/collections/hop-up-parts-for-traxxas-x-maxx-4x4-with-widemaxx':'1/5 X-Maxx w/WideMaxx',
    '/collections/hop-up-parts-for-traxxas-maxx-v2-with-widemaxx':'1/10 Maxx 4S / Maxx V2 WideMaxx',
    '/collections/hop-up-parts-for-traxxas-x-maxx-4x4-1':'1/5 X-Maxx / X-Monster',
    '/collections/hop-up-parts-for-traxxas-1-5-x-maxx':'1/5 X-Maxx / X-Monster',
    '/collections/hop-up-parts-for-traxxas-1-10-stampede-4x4-2023':"1/10 Stampede 4X4 (-'23)",
    '/collections/hop-up-parts-for-traxxas-1-10-stampede-4x4-bl-2s-ehd':'1/10 Stampede / Bigfoot 4X4 BL-2s'
  };
  var INDEXED_STOCK_HANDLES={
    'all':1,'all-integy-hop-up-parts':1,'hopups-for-traxxas':1,'hop-up-parts-for-traxxas':1,'parts-for-traxxas':1
  };

  function routeFor(anchor){
    try {
      var u=new URL(anchor.href,location.href);
      if(u.origin!==location.origin)return null;
      return String(u.pathname||'').replace(/\/$/,'').toLowerCase();
    } catch(error){ return null; }
  }

  function replaceVisibleLabel(anchor,label){
    if(!anchor||!label)return;
    var walker=document.createTreeWalker(anchor,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      var value=String(node.nodeValue||'');
      if(value.trim()){
        node.nodeValue=value.replace(value.trim(),label);
        anchor.setAttribute('data-integy-v655-canonical-label','true');
        return;
      }
    }
    anchor.appendChild(document.createTextNode(label));
    anchor.setAttribute('data-integy-v655-canonical-label','true');
  }

  function addDefaultStockToMenuLink(anchor){
    try {
      var u=new URL(anchor.href,location.href);
      if(u.origin!==location.origin || u.pathname.indexOf('/collections/')!==0)return;
      if(u.searchParams.has('filter.v.availability') || u.searchParams.has('integy_stock'))return;
      var parts=u.pathname.split('/').filter(Boolean);
      var at=parts.indexOf('collections');
      var handle=at>=0&&parts[at+1]?decodeURIComponent(parts[at+1]).toLowerCase():'';
      if(!handle)return;
      if(INDEXED_STOCK_HANDLES[handle])u.searchParams.set('integy_stock','in');
      else u.searchParams.set('filter.v.availability','1');
      anchor.href=u.pathname+'?'+u.searchParams.toString()+u.hash;
    } catch(error){}
  }

  function normalizeNavigation(){
    var selectors=[
      '[data-navmenu] a[href]',
      '[data-meganav-menu] a[href]',
      '.integy-v547-vehicle-model-grid a[href]',
      '.integy-v547-mobile-models a[href]',
      '.site-navigation a[href]',
      '.site-header a[href]'
    ];
    var anchors=[];
    try { anchors=Array.prototype.slice.call(document.querySelectorAll(selectors.join(','))); } catch(error) { return; }

    anchors.forEach(function(anchor){
      var route=routeFor(anchor);
      if(route && ROUTE_LABELS[route]) replaceVisibleLabel(anchor,ROUTE_LABELS[route]);
      addDefaultStockToMenuLink(anchor);
    });

    // Remove only exact repeated canonical Traxxas model links within the same local menu panel.
    var scopes=document.querySelectorAll('.integy-v547-vehicle-model-grid,.integy-v547-mobile-models,[data-meganav-menu]');
    Array.prototype.forEach.call(scopes,function(scope){
      var seen=Object.create(null);
      var links=scope.querySelectorAll('a[data-integy-v655-canonical-label="true"]');
      Array.prototype.forEach.call(links,function(anchor){
        var route=routeFor(anchor);
        if(!route)return;
        var label=String(anchor.textContent||'').trim().toLowerCase();
        var key=route+'|'+label;
        if(seen[key]){
          anchor.classList.add('integy-v655-nav-duplicate');
          anchor.setAttribute('aria-hidden','true');
          anchor.setAttribute('tabindex','-1');
        } else {
          seen[key]=anchor;
          anchor.classList.remove('integy-v655-nav-duplicate');
          anchor.removeAttribute('aria-hidden');
          anchor.removeAttribute('tabindex');
        }
      });
    });
  }

  function run(){ normalizeNavigation(); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  window.addEventListener('pageshow',run);
  document.addEventListener('shopify:section:load',run);
})();
